import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

interface MembershipAccordionHeaderProps {
  readonly headerMsgKey: string;
  readonly dataCy?: string;
}

const MembershipAccordionHeader = ({
  headerMsgKey,
  dataCy,
}: MembershipAccordionHeaderProps) => {
  const t = useTranslations();
  const header = t(headerMsgKey);

  return (
    <Typography
      weight="bold"
      color="dark"
      className="text-base lg:text-xl"
      data-cy={dataCy}
    >
      {header}
    </Typography>
  );
};
export default MembershipAccordionHeader;
